<template>
  <div
    class="tw:w-full tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:border tw:border-gray-300 tw:rounded-xl tw:py-3 tw:px-3 tw:md:px-5"
  >
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:items-center tw:gap-2">
      <div class="tw:flex tw:gap-x-1">
        <img :src="ios" alt="iOS" />
        <img :src="android" alt="Android" />
        <img :src="web" alt="Web" />
      </div>
      <p class="tw:text-sm" v-html="$t('plus_badges_info_text')" />
    </div>
    <CheckPropertyLink source="studio-plus-insights" :isBlue="true" />
  </div>
</template>
<script setup>
import CheckPropertyLink from '@/components/dashboard/CheckPropertyLink.vue'

const android = new URL('/src/assets/img/studio-plus-insights/android-icon.svg', import.meta.url)
const ios = new URL('/src/assets/img/studio-plus-insights/ios-icon.svg', import.meta.url)
const web = new URL('/src/assets/img/studio-plus-insights/web-icon.svg', import.meta.url)
</script>
<style scoped>
p:deep(b) {
  color: var(--tw-color-green-700);
}
</style>
